import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatTanggal } from "../../../Utils";

const generateHarianVBelanjaPDF = (data, tglmulai, tglakhir) => {
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.getWidth();

  const loadImageAsDataURL = (url) => {
    return fetch(url)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  };

const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 10;
  const logoSize = 15;
  const textX = logoX + logoSize + 2;

  if (logoDataUrl) {
    try {
      const imgType =
        typeof logoDataUrl === "string" &&
        logoDataUrl.startsWith("data:image/png")
          ? "PNG"
          : "JPEG";

      doc.addImage(
        logoDataUrl,
        imgType,
        logoX,
        logoY,
        logoSize,
        logoSize
      );
    } catch (e) {
      console.warn("Gagal menambahkan logo:", e);
    }
  }

  const textY = logoY + logoSize / 2 - 1;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("KPRI SRI REJEKI", textX, textY);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No. 164 Kab.Malang", textX, textY + 5);

  const lineY = logoY + logoSize + 4;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 6;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(
    "Laporan Harian Simpanan V.Belanja",
    pageWidth / 2,
    reportY,
    { align: "center" }
  );

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    `Tanggal : ${formatTanggal(tglmulai)} s/d ${formatTanggal(tglakhir)}`,
    pageWidth / 2,
    reportY + 5,
    { align: "center" }
  );

  return reportY + 9;
};

  const toTitleCase = (str = "") =>
    str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const getTransaksi = (kdtrans) => {
    switch (String(kdtrans)) {
      case "1":
        return "Setoran";
      case "2":
        return "Penarikan";
      default:
        return kdtrans || "";
    }
  };

  // Total
  const totalDebet = data.reduce(
    (sum, item) => sum + Number(item.debet || 0),
    0
  );

  const totalKredit = data.reduce(
    (sum, item) => sum + Number(item.kredit || 0),
    0
  );

  // Data tabel
  const tableBody = data.map((item, index) => [
  index + 1,
  item.tgltransak ? formatTanggal(item.tgltransak) : "",
  item.notransassi || "", // No. Transaksi
  item.noanggota || "",
  toTitleCase(item.nama),
  getTransaksi(item.kdtrans),
  Number(item.debet || 0).toLocaleString("id-ID"),
  Number(item.kredit || 0).toLocaleString("id-ID"),
]);

const renderTableAndExport = (startY) => {
  autoTable(doc, {
    startY,
    theme: "grid",

    head: [[
      "No.",
      "Tanggal",
      "No. Transaksi",
      "No.Anggota",
      "Nama",
      "Transaksi",
      "Debet",
      "Kredit",
    ]],

    body: tableBody,

    foot: [[
      {
        content: "Total Keseluruhan",
        colSpan: 6,
        styles: {
          halign: "center",
          fontStyle: "bold",
        },
      },
      {
        content: totalDebet.toLocaleString("id-ID"),
        styles: {
          halign: "right",
          fontStyle: "bold",
        },
      },
      {
        content: totalKredit.toLocaleString("id-ID"),
        styles: {
          halign: "right",
          fontStyle: "bold",
        },
      },
    ]],

    showFoot: "lastPage",

    styles: {
      fontSize: 8,
      cellPadding: 2,
      valign: "middle",
    },

    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
      fillColor: [0, 191, 165],
      textColor: 255,
    },

    footStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
    },

    margin: {
      left: 8,
      right: 8,
      top: 20,
      bottom: 10,
    },

    columnStyles: {
      0: { cellWidth: 10, halign: "center" },
      1: { cellWidth: 25, halign: "center" },
      2: { cellWidth: 25, halign: "center" }, // No. Transaksi
      3: { cellWidth: 25, halign: "center" }, // No.Anggota
      4: { cellWidth: 40, halign: "left" },   // Nama
      5: { cellWidth: 25, halign: "left" },   // Transaksi
      6: { cellWidth: 20, halign: "right" },  // Debet
      7: { cellWidth: 20, halign: "right" },  // Kredit
    },

    didDrawPage: (tableData) => {
      doc.setFontSize(8);
      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        tableData.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};

const customLogoUrl = window.location.origin + "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(logoDataUrl);
    renderTableAndExport(startY);
  })
  .catch(() => {
    const startY = drawHeader();
    renderTableAndExport(startY);
  });
};

export default generateHarianVBelanjaPDF;